export default __webpack_public_path__ + "static/media/helping.4b8d780d.svg";